import { render, staticRenderFns } from "./ReceptionEmail.vue?vue&type=template&id=d614ae52&scoped=true"
import script from "./ReceptionEmail.vue?vue&type=script&lang=js"
export * from "./ReceptionEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d614ae52",
  null
  
)

export default component.exports